"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _Skeleton = require("../Skeleton");
var _CourierBox = require("./CourierBox");
var _styles = require("./styles");
var _useCourierSelection = require("./useCourierSelection");
var _jsxRuntime = require("react/jsx-runtime");
const CourierSelection = props => {
  const {
    activeCourier,
    hintMessages,
    isRefreshPending,
    isSelectedDeliveryLoading,
    onShippingOfferBannerClick
  } = props;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    activateCourier,
    couriers,
    isCouriersLoading
  } = (0, _useCourierSelection.useCourierSelection)(props);
  const isLoading = isCouriersLoading || isSelectedDeliveryLoading || isRefreshPending;
  if (isLoading && !couriers) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.CourierBoxSkeleton, {});
  }
  if (!couriers || couriers.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FormControlWrapper, {
    ...getTestIdProps(_models.TestId.CourierSelection),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.RadioGroup, {
      "aria-labelledby": "courier-group",
      name: "controlled-radio-buttons-group",
      value: activeCourier,
      children: couriers.map(courier => {
        const {
          deliveryChannelId,
          name
        } = courier;
        const isActive = Boolean(activeCourier === deliveryChannelId);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CourierControl, {
          value: deliveryChannelId,
          "data-courier-name": name,
          control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CourierRadio, {
            checked: isActive,
            disabled: isLoading,
            onChange: activateCourier,
            ...getTestIdProps(_models.TestId.CourierRadioButton)
          }),
          label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CourierBox.CourierBox, {
            courier: courier,
            hintMessages: hintMessages,
            isActive: isActive,
            isDisabled: isLoading,
            onShippingOfferBannerClick: onShippingOfferBannerClick
          }, deliveryChannelId)
        }, deliveryChannelId);
      })
    })
  });
};
var _default = exports.default = CourierSelection;